import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestService } from '../../../../services/request.service';
import { DischargeInfo, RequestDto } from '../../../../models/request.dto';
import { EnrollementData } from '../../../../models/enrollement-data.model';

@Component({
  selector: 'app-enrollement-info',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  templateUrl: './enrollement-info.component.html',
  styleUrl: './enrollement-info.component.scss',
})
export class EnrollementInfoComponent {
  @Input() visibleFields: string[] = [];
  @Input() request!: RequestDto;
  @Input() enrollementData: EnrollementData | undefined;
  @Input() dischargeInfo: DischargeInfo[] =[];

  loading: boolean = true;

  constructor(private requestService: RequestService) {}

  ngOnInit(): void {
    this.loading = false;
    // if (this.request?.id) {
    //   this.requestService.getDischargeInfo(this.request.id).subscribe({
    //     next: (data) => {
    //       this.dischargeInfo = data;
    //       this.loading = false;
    //     },
    //     error: () => {
    //       this.loading = false;
    //     },
    //   });
    // }
  }

  getDateFromType(dateType: string): any {
    return this.dischargeInfo.find(d => d.dateType.code == dateType);
  }
}
